
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class QueueTypeDialog extends SiteEntityDialog<QueueTypeRow, any> {
        protected getFormKey() { return QueueTypeForm.formKey; }
        protected getIdProperty() { return QueueTypeRow.idProperty; }
        protected getLocalTextPrefix() { return QueueTypeRow.localTextPrefix; }
        protected getNameProperty() { return QueueTypeRow.nameProperty; }
        protected getService() { return QueueTypeService.baseUrl; }
        protected getDeletePermission() { return QueueTypeRow.deletePermission; }
        protected getInsertPermission() { return QueueTypeRow.insertPermission; }
        protected getUpdatePermission() { return QueueTypeRow.updatePermission; }

        protected form = new QueueTypeForm(this.idPrefix);

    }
}